import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import CrmOpportunityActions from 'actions/crm-opp-ui/CrmOpportunityActions';
import CrmOpportunityStore from 'stores/crm-opp-ui/CrmOpportunityStore';
import SearchAndResultsContainer from './SearchAndResultsContainer';

@connectToStores
class OpportunitySearch extends React.Component {
  constructor(props) {
    super(props);
    this.entityClick = this.entityClick.bind(this);
  }

  entityClick(entity) {
    this.props.selectEntity(entity);
    CrmOpportunityActions.setSearchTerm(entity.name);
  }

  static getStores() {
    return [CrmOpportunityStore];
  }
  static getPropsFromStores() {
    const store = CrmOpportunityStore.getState();
    return {
      searchResults: store.searchResults,
      searchTerm: store.searchTerm,
      isSearching: store.isSearching,
    };
  }

  render() {
    const {
      autoFocus,
      searchResults,
      searchTerm,
      entityLoaded,
      isSearching,
      placeholder = 'Type opportunity or account name to search',
      className,
      searchDisabled = false,
    } = this.props;

    const filteredResults = this.props.filterResults
      ? this.props.filterResults(searchResults)
      : searchResults;

    return (
      <SearchAndResultsContainer
        autoFocus={autoFocus}
        placeholder={placeholder}
        executeSearch={CrmOpportunityActions.searchOpportunities}
        tabIndex={2}
        searchResults={filteredResults}
        searchTerm={searchTerm}
        selectEntity={this.entityClick}
        entityLoaded={entityLoaded}
        isSearching={isSearching}
        className={className}
        searchDisabled={searchDisabled}
      />
    );
  }
}

export default OpportunitySearch;
